import React from 'react';
import { ResponsiveLine } from '@nivo/line';

export const Line = (props) => {
  const {
 data = [], yLabel, xLabel, hideLegend,
} = props;

  return (
    <ResponsiveLine
      data={data}
      margin={{
        top: 10, right: 10, bottom: 100, left: 60,
      }}
      xScale={{ type: 'point' }}
      yScale={{
        type: 'linear',
        min: 'auto',
        max: 'auto',
        stacked: false,
        reverse: false,
      }}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        orient: 'bottom',
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: xLabel,
        legendOffset: 40,
        legendPosition: 'middle',
        format: (v) => {
          if (v.includes('Q')) {
            const shouldShow = v.includes('Q1');
            return shouldShow ? `'${v.slice(2, 4)}` : '';
          }
          return `'${v.slice(2, 4)}`;
        },
      }}
      axisLeft={{
        orient: 'left',
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: yLabel,
        legendOffset: -50,
        legendPosition: 'middle',
      }}
      // colors={{ scheme: 'set2' }}
      colors={['#66C2A4', '#8DA0CA', '#E68AC2', '#FEAB8A', '#A5D853', '#E4C494', '#B3B3B3']}
      colorBy="index"
      pointSize={3}
      pointColor={{ theme: 'background' }}
      pointBorderWidth={2}
      pointBorderColor={{ from: 'serieColor' }}
      pointLabel="y"
      pointLabelYOffset={-12}
      useMesh
      enableSlices="x"
      legends={hideLegend ? [] : [
        {
          anchor: 'bottom',
          direction: 'row',
          justify: false,
          translateX: 0,
          translateY: 70,
          itemsSpacing: 35,
          itemDirection: 'left-to-right',
          itemWidth: 80,
          itemHeight: 20,
          itemOpacity: 0.75,
          symbolSize: 12,
          symbolShape: 'circle',
          symbolBorderColor: 'rgba(0, 0, 0, .5)',
          effects: [
            {
              on: 'hover',
              style: {
                itemBackground: 'rgba(0, 0, 0, .03)',
                itemOpacity: 1,
              },
            },
          ],
        },
      ]}
    />
  );
};
